var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-skeleton-loader',{staticClass:"wl-login-loader",attrs:{"type":"avatar "}}),_c('h1',{staticClass:"wl-login-loader"},[_vm._v("Linking Brokerage ...")]),_c('v-progress-linear',{attrs:{"height":"2","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }